<template>
  <div
    class="wishlist-toast-content flex items-center gap-3"
    :class="{ 'wishlist-toast-content--with-photo': room?.photo }"
  >
    <img
      v-if="room?.photo"
      :src="room.photo"
      :alt="room.name"
      class="w-10 h-10 shrink-0 rounded object-cover"
    >

    <div class="min-w-0 mr-3">
      <div>{{ message }}</div>
      <div
        v-if="roomLabel"
        class="truncate text-grey-600"
      >
        {{ roomLabel }}
      </div>
    </div>

    <BaseButton
      color="text"
      class="shrink-0 ml-auto"
      :href="FAVOURITES_URL"
      data-test-id="wishlist-toast-see-list"
    >
      See list
    </BaseButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

const FAVOURITES_URL = '/favourites';

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  room: {
    type: Object,
    default: null,
  },
});

const roomLabel = computed(() => props.room?.venueName ?? props.room?.name ?? '');
</script>

<style lang="scss" scoped>
// Fixed so stacked toasts line up: 340px in total (the screen minus 16px gaps on mobile), less the
// notification's padding (40px) and, without a thumbnail, its icon (28px).
$toaster-mobile-max: 600px; // vue-sonner's own mobile breakpoint, fixed in the library
$for-toaster-mobile: 'screen and (max-width: #{$toaster-mobile-max})';

.wishlist-toast-content {
  width: 272px;
}

.wishlist-toast-content--with-photo {
  width: 300px;
}

@media #{$for-toaster-mobile} {
  .wishlist-toast-content {
    width: calc(100vw - 100px);
  }

  .wishlist-toast-content--with-photo {
    width: calc(100vw - 72px);
  }
}
</style>
